import type { ViewConfigDimension } from '@salescore/core'
import { Array } from 'effect'
import { isNotNullish } from 'effect/Predicate'

/**
 * ピボットの列の columnFieldName に対応する分析軸の設定を探す
 */
export const findPivotColumnKpiParameter = (
  kpiParameterColumns: ViewConfigDimension[],
  columnFieldName: string,
): ViewConfigDimension | undefined =>
  kpiParameterColumns.find(
    (kc) =>
      // columnFieldNameと同じgenerateDimensionField.tsの「generateDimensionFieldName()」のフォーマットで比較
      Array.filter([kc.dateSpan, kc.key], isNotNullish).join('_') === columnFieldName,
  )
